import React, { useEffect, useState } from 'react';
import "./Category.css";
import { NavLink } from 'react-router-dom';
import { Icon } from 'react-icons-kit';
import { arrowUp } from 'react-icons-kit/feather/arrowUp';
import { trash } from 'react-icons-kit/feather/trash';
import { eye } from 'react-icons-kit/feather/eye';
import { arrowUpRight } from 'react-icons-kit/feather/arrowUpRight';
import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { useJwt } from "react-jwt";
import { DeleteSubCategory, GetSubcategoryPage ,api_url} from '../apiconfig/authService';
import { Pagination } from "rsuite";
import 'rsuite/dist/rsuite.min.css';

function Subcategory(props) {
    const navigate = useNavigate();
    const { isExpired } = useJwt(localStorage.getItem('accessToken'));
    if (isExpired)
        navigate('/');

    const message = props.message;
    const [subcategoriesData, setSubcategoriesData] = useState([]);

    const [refetchData, setRefetchData] = useState(false);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [totalSubcategories, setTotalSubcategories] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [recordIdToDelete, setRecordIdToDelete] = useState('');


    const handlePerPageRecordsChange = (e) => {
        setItemsPerPage(e.target.value);
        setPageCount(1);
    };

    const formatUTCDate = (utcDateString) => {
        const date = new Date(utcDateString);
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZoneName: 'short',
        };
        const readableFormat = date.toLocaleString(undefined, options);
        return readableFormat.substring(0, readableFormat.length - 9);
    };


    useEffect(() => {
        (
            async () => {
                try {
                    const subcategoriesResponse = await GetSubcategoryPage(page, itemsPerPage, search, localStorage.getItem('accessToken'));
                    setSubcategoriesData(subcategoriesResponse.data.subcategories.items);
                    setPageCount(Math.ceil(subcategoriesResponse.data.subcategories.pagination.pageCount));
                    setTotalSubcategories(subcategoriesResponse.data.subcategories.pagination.count);
                } catch (error) {
                    console.log(error);
                }
            }
        )();
    }, [page, itemsPerPage, refetchData]);

    const handleDeleteSubcategoryClick = async (subcategoryid) => {
        try {
            await DeleteSubCategory(subcategoryid, localStorage.getItem('accessToken'));
            const temp = [...subcategoriesData];
            const index = temp.findIndex((item) => item.subcategoryid === subcategoryid);
            temp.splice(index, 1);
            setSubcategoriesData(temp);
            setTotalSubcategories(totalSubcategories - 1);
        } catch (error) {
            console.log(error);
        }
    };

    const handleViewSubcategoryClick = (subcategoryid) => {
        navigate(`/viewSubcategory/${subcategoryid}`);
    };
    const handleEditSubcategoryClick = (subcategoryid) => {
        navigate(`/editSubcategory/${subcategoryid}`);
    };

    const handlePrevious = () => {
        setPage((p) => {
            if (p === 1) return p;
            return p - 1;
        });
    };
    const handleNext = () => {
        setPage((p) => {
            if (p === pageCount) return p;
            return p + 1;
        });
    };

    const handleSearchBoxSubmit = (event) => {
        event.preventDefault();
        setPage(1);
        setRefetchData(!refetchData)
    };

    return (
        <div className="dashboard-content">
            {/* <div className="mobileOption d-flex align-items-center justify-content-between">
                <div  className="buyMore"><img className="img-fluid" src={logoImg} alt=""/></div>
                <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
            </div> */}
            <Sidebar />
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Subcategory Management<br /><small className="text-primary h6 fw-bold">Total counts {totalSubcategories}</small></h1>
                    <div className="d-inline-flex gap-2">
                        <NavLink to="/addSubcategory" className="btn btn-primary addSeller">Add Subcategory</NavLink>
                    </div>
                </div>
                <div className="collapse mb-4" id="filter">
                    <div className="card card-body">
                        <form className="filterForm" action="/">
                            <div className="row">
                                <div className="col-lg-12 mb-2">
                                    <h4 className="text-primary h6 fw-bold">Filter Things</h4>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4 mb-2">
                                    <div className="form-floating">
                                        <select className="form-select" id="floatBilling" aria-label="Billing">
                                            <option defaultValue>Select</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </select>
                                        <label htmlFor="floatBilling">Billing</label>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb-2">
                                    <div className="form-floating">
                                        <select className="form-select" id="floatStatus" aria-label="Status">
                                            <option defaultValue>Select</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </select>
                                        <label htmlFor="floatStatus">Status</label>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb-2">
                                    <button type="submit" className="btn btn-primary btn-lg save-btn text-uppercase w-100">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="searchList row">
                    <div className="displayRecord d-flex align-items-center col-lg-6 mb-2">
                        <span className="h6 mb-0">Display Records</span>
                        <select className="form-select" value={itemsPerPage} onChange={handlePerPageRecordsChange}>
                            <option defaultValue="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                        </select>
                    </div>
                    <div className="searchForm d-flex justify-content-end col-lg-6 mb-2">
                        <form className="sForm" onSubmit={handleSearchBoxSubmit}>
                            <input type="text" onChange={(event) => { setSearch(event.target.value) }} className="form-control form-control-lg w-100" id="s" placeholder="Search" />
                        </form>
                    </div>
                </div>
                {message && <div className="alert alert-primary" role="alert">{message}</div>}
                <div className="table-responsive">
                    <table className="table table-borderless table-hover">
                        <thead>
                            <tr>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '50px' }} scope="col" width="45" align="center">
                                    <div className="selectAll">
                                        <input className="form-check-input" type="checkbox" />
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '80px' }} scope="col" width="80">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">SR.</span>
                                        <button className="filtBtn idFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '100px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Name</span>
                                        <button className="filtBtn fNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th>
                                <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px'}}  scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Image</span>
                                        <button className="filtBtn lNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18}/></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '200px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Category</span>
                                        <button className="filtBtn lNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '120px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Status</span>
                                        <button className="filtBtn lNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '220px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Created Date</span>
                                        <button className="filtBtn statusFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '220px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Modified Date</span>
                                        <button className="filtBtn emailFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '100px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Created By</span>
                                        <button className="filtBtn emailFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '100px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Modified By</span>
                                        <button className="filtBtn emailFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Action</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="table-group-divider">
                            {
                                subcategoriesData?.map((item, index) => (
                                    <tr key={item._id}>
                                        <td><input className="form-check-input" type="checkbox" /></td>
                                        <td>{index + 1}</td>
                                        <td>{item.name}</td>
                                        <td><img width="100px" height="100px" src={`${api_url}/product/category/getCategoryImage/${item.image}`}/></td>
                                        <td>{item.categoryInfo.name}</td>
                                        <td>{item.statusInfo.status}</td>
                                        <td>{formatUTCDate(item.createddate)}</td>
                                        <td>{formatUTCDate(item.modifieddate)}</td>
                                        <td>{item.createdby}</td>
                                        <td>{item.modifiedby}</td>
                                        <td>
                                            <div className="d-grid gap-2 d-md-block">
                                                <button type="button" onClick={() => { handleViewSubcategoryClick(item.subcategoryid) }} className="actBtn viewBtn">
                                                    <Icon className="eye" icon={eye} size={18} />
                                                    <span className="toolTip">Preview</span>
                                                </button>
                                                <button type="button" onClick={() => { handleEditSubcategoryClick(item.subcategoryid) }} className="actBtn editBtn">
                                                    <Icon className="arrowUpRight" icon={arrowUpRight} size={18} />
                                                    <span className="toolTip">Edit</span>
                                                </button> &nbsp;
                                                <button type="button" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => { setRecordIdToDelete(item.subcategoryid) }} className="actBtn delBtn">
                                                    <Icon className="trash" icon={trash} size={18} />
                                                    <span className="toolTip">Delete</span>
                                                </button> &nbsp;
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
                <div className="resultList pt-3 border-top">
                <div className="row">
                        <div className="d-flex justify-content-between displayRecord col mb-2">
                            {/* <div className=" pb-[20px] pl-[20px] pr-[20px] w-full flex justify-between mt-3"> */}
                            {totalSubcategories === 0 ? <div>Showing 0 - 0 of 0 entries. </div> :
                                (<div>Showing {(page - 1) * itemsPerPage + 1} - {totalSubcategories < (itemsPerPage * page) ? totalSubcategories : itemsPerPage * page} of {totalSubcategories} entries.</div>)}
                            {/* Pagination Start */}
                            <div>
                                <Pagination
                                    prev
                                    last
                                    next
                                    first
                                    size='sm'
                                    ellipsis
                                    boundaryLinks
                                    onSelect={setPage}
                                    limit={itemsPerPage}
                                    onChangeLimit={setItemsPerPage}
                                    layout={['pager', 'skip']}
                                    pages={pageCount}
                                    total={totalSubcategories}
                                    maxButtons={5}
                                    activePage={page}
                                    onChangePage={(page) => { setPage(page) }}
                                />
                            </div>
                            {/* Pagination End */}
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="exampleModal" tabIndex="10" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body text-center p-5">
                                <h1 className="modal-title display-6 mb-4" id="exampleModalLabel">Procced with delete?</h1>
                                <button type="button" className="btn btn-danger me-2" data-bs-dismiss="modal">No</button>
                                <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => { handleDeleteSubcategoryClick(recordIdToDelete) }}>Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Subcategory;
